(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dorsa-lp-sticky-cta"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dorsa-sticky-cta')) {
  customElements.define('dorsa-sticky-cta', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const update = () => {
        this.frame = null;
        const desktop = window.innerWidth >= 750;
        const distance = Number(desktop ? this.dataset.scrollDesktop : this.dataset.scrollMobile) || 0;
        const editing = document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
        const visible = (!desktop || this.dataset.desktopEnabled === 'true') && window.scrollY >= distance && !editing;
        if (this.hidden === !visible) return;
        this.hidden = !visible;
        this.inert = !visible;
        this.setAttribute('aria-hidden', String(!visible));
      };
      const schedule = () => {
        if (this.frame == null) this.frame = requestAnimationFrame(update);
      };
      window.addEventListener('scroll', schedule, { passive: true, signal });
      window.addEventListener('resize', schedule, { passive: true, signal });
      window.addEventListener('pageshow', schedule, { signal });
      document.addEventListener('focusin', schedule, { signal });
      document.addEventListener('focusout', schedule, { signal });
      update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      if (this.frame != null) cancelAnimationFrame(this.frame);
      this.frame = null;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dorsa-velar-direct-aftercare"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dorsa-velar-aftercare')) {
  customElements.define('dorsa-velar-aftercare', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;




      this.abort = new AbortController();
      const signal = this.abort.signal;




      /*
       * ============================================================
       * THEME EDITOR MODULE ORDER / VISIBILITY
       * ============================================================
       * The three module control blocks can be dragged in the Theme
       * Editor. Their order becomes the storefront order. If the
       * controls have not been added yet, the existing setup → room
       * → FAQ order remains untouched.
       */
      const moduleMap = this.querySelector('[data-vda-module-order-map]');
      const moduleNodes = {
        setup: this.querySelector('[data-vda-module="setup"]'),
        room: this.querySelector('[data-vda-module="room"]'),
        faq: this.querySelector('[data-vda-module="faq"]')
      };
      const moduleControls = moduleMap
        ? Array.from(moduleMap.querySelectorAll('[data-vda-module-control]'))
        : [];




      if (moduleControls.length) {
        const explicit = [];




        moduleControls.forEach(control => {
          const key = control.dataset.vdaModuleControl;
          const node = moduleNodes[key];
          if (!node) return;




          explicit.push(key);
          node.hidden = control.dataset.enabled === 'false';
        });




        ['setup', 'room', 'faq']
          .filter(key => !explicit.includes(key))
          .forEach(key => explicit.push(key));




        explicit.forEach(key => {
          const node = moduleNodes[key];
          if (node) this.appendChild(node);
        });
      }




      const form = this.querySelector('[data-velar-room-form]');
      const submit = this.querySelector('[data-velar-room-submit]');
      const status = this.querySelector('[data-velar-room-status]');
      const success = this.querySelector('[data-velar-room-success]');
      const fileInput = this.querySelector('[data-velar-file-input]');
      const fileName = this.querySelector('[data-velar-file-name]');
      const upload = this.querySelector('[data-velar-upload]');
      const consent = this.querySelector('[data-vda-consent]');
      const consentInput = this.querySelector('[data-vda-consent-input]');
      const consentText = this.querySelector('[data-vda-consent-gesture] span');
      const fullName = this.querySelector('[data-vda-full-name]');
      const mobile = this.querySelector('[data-vda-mobile]');
      const email = form?.querySelector('input[name="email"]');
      const colour = form?.querySelector('select[name="velar_colour"]');




      /*
       * ============================================================
       * SESSION + ATTRIBUTION
       * ============================================================
       */




      const safeSessionGet = key => {
        try {
          return sessionStorage.getItem(key) || '';
        } catch (_) {
          return '';
        }
      };




      const safeSessionSet = (key, value) => {
        try {
          sessionStorage.setItem(key, value);
        } catch (_) {}
      };




      const safeSessionRemove = key => {
        try {
          sessionStorage.removeItem(key);
        } catch (_) {}
      };




      const createId = () => {
        if (window.crypto?.randomUUID) {
          return crypto.randomUUID();
        }




        return `velar-${Date.now()}-${Math.random()
          .toString(36)
          .slice(2, 10)}`;
      };




      const sessionIdKey = 'dorsa_velar_room_session_id';




      const sessionId =
        safeSessionGet(sessionIdKey) ||
        createId();




      safeSessionSet(sessionIdKey, sessionId);




      const seenPrefix =
        `dorsa_velar_seen_${sessionId}_`;




      const getCookie = name => {
        const prefix = `${name}=`;




        const row = document.cookie
          .split('; ')
          .find(item => item.startsWith(prefix));




        return row
          ? decodeURIComponent(row.slice(prefix.length))
          : '';
      };




      const query =
        new URLSearchParams(location.search);




      const attributionKeys = [
        'utm_source',
        'utm_medium',
        'utm_campaign',
        'utm_content',
        'utm_term',
        'fbclid'
      ];




      const attribution = {};




      attributionKeys.forEach(key => {
        const storeKey =
          `dorsa_velar_${key}`;




        const incoming =
          query.get(key) || '';




        if (incoming) {
          safeSessionSet(
            storeKey,
            incoming
          );
        }




        attribution[key] =
          incoming ||
          safeSessionGet(storeKey);
      });




      attribution.fbp =
        getCookie('_fbp');




      attribution.fbc =
        getCookie('_fbc');




      if (
        !safeSessionGet(
          'dorsa_velar_landing_url'
        )
      ) {
        safeSessionSet(
          'dorsa_velar_landing_url',
          location.href
        );
      }




      let started = false;
      let completed = false;




      /*
       * ============================================================
       * GTM / SHOPIFY CUSTOM EVENTS
       * NO CONTACT DATA IS SENT HERE
       * ============================================================
       */




      const baseEventData = extra => ({
        product_name:
          this.dataset.productTitle,
        product_handle:
          this.dataset.productHandle,
        product_id:
          this.dataset.productId,
        room_preview_session_id:
          sessionId,
        ...extra
      });




      const publish = (
        eventName,
        extra = {}
      ) => {
        const eventData =
          baseEventData(extra);




        window.dataLayer =
          window.dataLayer || [];




        window.dataLayer.push({
          event: eventName,
          ...eventData
        });




        /*
         * Publish the same behavioural event
         * into Shopify Customer Events where
         * supported.
         */




        try {
          const result =
            window.Shopify
              ?.analytics
              ?.publish?.(
                `dorsa:${eventName}`,
                eventData
              );




          result?.catch?.(() => {});
        } catch (_) {}
      };




      /*
       * ============================================================
       * VALIDATION
       * ============================================================
       */




      const validateContact = () => {
        if (fullName) {
          fullName.setCustomValidity(
            fullName.value
              .trim()
              .length >= 2
              ? ''
              : this.dataset
                  .fullNameError
          );
        }




        if (mobile) {
          const value =
            mobile.value.trim();




          if (!value) {
            mobile.setCustomValidity(
              ''
            );
          } else {
            const digits =
              value.replace(/\D/g, '');




            const valid =
              /^\+?[\d\s().-]+$/.test(
                value
              ) &&
              digits.length >= 8 &&
              digits.length <= 15;




            mobile.setCustomValidity(
              valid
                ? ''
                : this.dataset
                    .mobileError
            );
          }
        }
      };




      const validName = () =>
        Boolean(
          fullName?.value
            .trim()
            .length >= 2
        );




      const hasMobile = () =>
        Boolean(
          mobile?.value
            .trim()
        );




      const validMobile = () => {
        const value =
          mobile?.value.trim() || '';




        if (!value) {
          return true;
        }




        const digits =
          value.replace(/\D/g, '');




        return (
          /^\+?[\d\s().-]+$/.test(
            value
          ) &&
          digits.length >= 8 &&
          digits.length <= 15
        );
      };




      const validEmail = () =>
        Boolean(
          email?.value &&
          email.checkValidity()
        );




      /*
       * ============================================================
       * BASIN TELEMETRY
       * THIS IS WHERE PARTIAL CONTACT DETAILS ARE SAVED
       * ============================================================
       */




      const snapshot = (
        eventName,
        extra = {}
      ) => ({
        form_name:
          'VELAR Room Preview telemetry',




        submission_type:
          'VELAR Room Preview telemetry',




        event:
          eventName,




        form_status:
          completed
            ? 'completed'
            : 'incomplete',




        room_preview_session_id:
          sessionId,




        product:
          this.dataset
            .productTitle || '',




        product_handle:
          this.dataset
            .productHandle || '',




        product_id:
          this.dataset
            .productId || '',




        full_name:
          fullName?.value
            .trim() || '',




        mobile:
          mobile?.value
            .trim() || '',




        email:
          email?.value
            .trim() || '',




        velar_colour:
          colour?.value || '',




        photo_selected:
          fileInput
            ?.files
            ?.length
            ? 'yes'
            : 'no',




        /*
         * Ordinary telemetry carries only
         * photo metadata. The actual image
         * is handled separately by the
         * secure Basin draft upload below.
         */




        photo_name:
          fileInput
            ?.files?.[0]
            ?.name || '',




        marketing_consent:
          consentInput?.checked
            ? 'yes'
            : 'no',




        page_url:
          location.href,




        landing_url:
          safeSessionGet(
            'dorsa_velar_landing_url'
          ) ||
          location.href,




        referrer:
          document.referrer || '',




        timestamp:
          new Date()
            .toISOString(),




        ...attribution,
        ...extra
      });




      const toFormData = data => {
        const fd =
          new FormData();




        Object.entries(data)
          .forEach(
            ([key, value]) => {
              if (
                value !== undefined &&
                value !== null
              ) {
                fd.append(
                  key,
                  String(value)
                );
              }
            }
          );




        return fd;
      };




      /*
       * Uses the existing Basin endpoint
       * from the form.
       *
       * If you ever add:
       *
       * data-telemetry-endpoint="..."
       *
       * to <dorsa-velar-aftercare>,
       * it will automatically use that
       * separate endpoint instead.
       */




      const telemetryEndpoint =
        this.dataset
          .telemetryEndpoint ||
        form?.action ||
        '';




      const saveRoomPhotoDraft =
        async file => {
          if (
            !file ||
            !telemetryEndpoint
          ) {
            return false;
          }




          const data =
            snapshot(
              'velar_room_photo_draft',
              {
                form_name:
                  'VELAR Room Preview draft',
                submission_type:
                  'VELAR Room Preview draft',
                form_status:
                  'draft',
                last_completed_field:
                  'room_photo',
                file_type:
                  file.type || '',
                file_size:
                  file.size || 0
              }
            );




          const fd =
            toFormData(
              data
            );




          /*
           * The actual image is intentionally
           * sent only to Basin. It is never
           * pushed into dataLayer, Shopify
           * Customer Events, Meta or Clarity.
           */
          fd.append(
            'room_photo',
            file,
            file.name
          );




          try {
            const response =
              await fetch(
                telemetryEndpoint,
                {
                  method: 'POST',
                  body: fd,
                  headers: {
                    Accept:
                      'application/json'
                  }
                }
              );




            if (!response.ok) {
              throw new Error(
                'Draft photo upload failed'
              );
            }




            return true;
          } catch (error) {
            console.error(
              '[DORSA VELAR] Room photo draft could not be saved.',
              error
            );




            return false;
          }
        };




      const telemetry = (
        eventName,
        extra = {},
        options = {}
      ) => {
        if (!telemetryEndpoint) {
          return;
        }




        const dedupeKey =
          `${seenPrefix}${eventName}`;




        if (
          !options.allowRepeat &&
          safeSessionGet(
            dedupeKey
          )
        ) {
          return;
        }




        if (
          !options.allowRepeat
        ) {
          safeSessionSet(
            dedupeKey,
            '1'
          );
        }




        const data =
          snapshot(
            eventName,
            extra
          );




        const fd =
          toFormData(data);




        /*
         * sendBeacon is used when the
         * person leaves the page so the
         * abandoned lead still has the
         * best chance of reaching Basin.
         */




        if (
          options.beacon &&
          navigator.sendBeacon
        ) {
          const queued =
            navigator.sendBeacon(
              telemetryEndpoint,
              fd
            );




          if (
            !queued &&
            !options.allowRepeat
          ) {
            safeSessionRemove(
              dedupeKey
            );
          }




          return;
        }




        fetch(
          telemetryEndpoint,
          {
            method: 'POST',
            body: fd,
            mode: 'no-cors',
            keepalive:
              Boolean(
                options.keepalive
              )
          }
        ).catch(() => {
          if (
            !options.allowRepeat
          ) {
            safeSessionRemove(
              dedupeKey
            );
          }
        });
      };




      const markStep = (
        eventName,
        stepIndex,
        lastCompletedField,
        extra = {}
      ) => {
        started = true;




        const safeExtra = {
          step_index:
            stepIndex,




          last_completed_field:
            lastCompletedField,




          ...extra
        };




        publish(
          eventName,
          safeExtra
        );




        telemetry(
          eventName,
          safeExtra
        );
      };




      /*
       * ============================================================
       * CONTACT FIELD VALIDATION
       * ============================================================
       */




      [fullName, mobile]
        .forEach(field => {
          field?.addEventListener(
            'input',
            validateContact,
            { signal }
          );




          field?.addEventListener(
            'change',
            validateContact,
            { signal }
          );
        });




      submit?.addEventListener(
        'click',
        validateContact,
        { signal }
      );




      form?.addEventListener(
        'keydown',
        event => {
          if (
            event.key === 'Enter'
          ) {
            validateContact();
          }
        },
        { signal }
      );




      form?.addEventListener(
        'reset',
        () => {
          queueMicrotask(
            validateContact
          );
        },
        { signal }
      );




      validateContact();




      /*
       * ============================================================
       * MARKETING CONSENT UI
       * ============================================================
       */




      const syncConsent = () => {
        if (
          !consent ||
          !consentInput
        ) {
          return;
        }




        consent.classList.toggle(
          'is-selected',
          consentInput.checked
        );




        if (consentText) {
          consentText.textContent =
            consentInput.checked
              ? this.dataset
                  .consentSelected
              : this.dataset
                  .consentIdle;
        }
      };




      consentInput?.addEventListener(
        'change',
        () => {
          syncConsent();




          if (
            consentInput.checked
          ) {
            markStep(
              'velar_marketing_opt_in',
              7,
              'marketing_consent'
            );
          }
        },
        { signal }
      );




      form?.addEventListener(
        'reset',
        () => {
          queueMicrotask(
            syncConsent
          );
        },
        { signal }
      );




      syncConsent();




      /*
       * ============================================================
       * PHOTO UPLOAD
       * ============================================================
       */




      if (
        fileInput &&
        fileName &&
        upload
      ) {
        const defaultText =
          fileName.textContent;




        fileInput.addEventListener(
          'change',
          async () => {
            const file =
              fileInput.files?.[0];




            upload.classList.toggle(
              'has-file',
              Boolean(file)
            );




            upload.classList.remove(
              'is-ready'
            );




            form?.classList.remove(
              'has-photo-ready'
            );




            if (!file) {
              fileName.textContent =
                defaultText;




              return;
            }




            if (
              file.size >
                20 *
                1024 *
                1024
            ) {
              fileName.textContent =
                'IMAGE TOO LARGE';




              if (status) {
                status.dataset.state =
                  'error';




                status.textContent =
                  'That image is over 20 MB. Please choose a smaller file.';
              }




              return;
            }




            fileName.textContent =
              'SECURING PHOTO…';




            markStep(
              'velar_room_photo_selected',
              6,
              'room_photo',
              {
                file_type:
                  file.type || '',
                file_size:
                  file.size || 0
              }
            );




            const saved =
              await saveRoomPhotoDraft(
                file
              );




            if (saved) {
              upload.classList.add(
                'is-ready'
              );




              form?.classList.add(
                'has-photo-ready'
              );




              fileName.textContent =
                'PHOTO READY';




              if (status) {
                status.dataset.state =
                  '';




                status.textContent =
                  'Photo secured. Complete the details below to receive your preview.';
              }




              return;
            }




            fileName.textContent =
              'PHOTO SELECTED';




            if (status) {
              status.dataset.state =
                'error';




              status.textContent =
                'The secure draft could not be saved yet. Re-select the image or submit the form now.';
            }
          },
          { signal }
        );
      }




      /*
       * ============================================================
       * START + STEP TRACKING
       * ============================================================
       */




      if (form) {
        /*
         * First interaction with the form.
         */




        form.addEventListener(
          'focusin',
          () => {
            started = true;




            publish(
              'velar_room_preview_start',
              {
                step_index: 0,
                last_completed_field: ''
              }
            );




            telemetry(
              'velar_room_preview_start',
              {
                step_index: 0,
                last_completed_field: ''
              }
            );
          },
          {
            once: true,
            signal
          }
        );




        /*
         * FULL NAME COMPLETED
         */




        fullName?.addEventListener(
          'change',
          () => {
            validateContact();




            if (validName()) {
              markStep(
                'velar_full_name_complete',
                1,
                'full_name'
              );
            }
          },
          { signal }
        );




        /*
         * MOBILE COMPLETED
         */




        mobile?.addEventListener(
          'change',
          () => {
            validateContact();




            if (
              hasMobile() &&
              validMobile()
            ) {
              markStep(
                'velar_mobile_complete',
                2,
                'mobile'
              );
            }
          },
          { signal }
        );




        /*
         * EMAIL COMPLETED
         */




        email?.addEventListener(
          'change',
          () => {
            if (validEmail()) {
              markStep(
                'velar_email_complete',
                3,
                'email'
              );
            }
          },
          { signal }
        );




        /*
         * ALL CONTACT DETAILS AVAILABLE
         */




        const checkContactComplete =
          () => {
            validateContact();




            if (
              validName() &&
              validMobile() &&
              validEmail()
            ) {
              markStep(
                'velar_contact_complete',
                4,
                'contact_details'
              );
            }
          };




        [
          fullName,
          mobile,
          email
        ].forEach(field => {
          field?.addEventListener(
            'change',
            checkContactComplete,
            { signal }
          );
        });




        /*
         * COLOUR SELECTED
         */




        colour?.addEventListener(
          'change',
          () => {
            if (colour.value) {
              markStep(
                'velar_colour_selected',
                5,
                'velar_colour',
                {
                  velar_colour:
                    colour.value
                }
              );
            }
          },
          { signal }
        );
      }




      /*
       * ============================================================
       * FINAL FORM SUBMISSION
       * ============================================================
       */




      if (
        form &&
        submit &&
        status &&
        success
      ) {
        submit.dataset.defaultLabel =
          submit.dataset
            .defaultLabel ||
          submit.textContent;




        submit.textContent =
          submit.dataset
            .defaultLabel;




        submit.disabled =
          false;




        form.addEventListener(
          'submit',
          async event => {
            event.preventDefault();




            if (
              submit.disabled
            ) {
              return;
            }




            validateContact();




            if (
              !form.checkValidity()
            ) {
              form.reportValidity();
              return;
            }




            const file =
              fileInput
                ?.files?.[0];




            if (
              file &&
              file.size >
                20 *
                1024 *
                1024
            ) {
              status.dataset.state =
                'error';




              status.textContent =
                'That image is over 20 MB. Please upload a smaller file.';




              return;
            }




            started = true;




            /*
             * Existing GTM event preserved.
             */




            publish(
              'velar_room_preview_submit',
              {
                velar_colour:
                  colour?.value || ''
              }
            );




            /*
             * Basin records the actual
             * attempted submission too.
             */




            telemetry(
              'velar_room_preview_submit_attempt',
              {
                step_index: 8,
                last_completed_field:
                  'submit'
              }
            );




            submit.disabled =
              true;




            submit.textContent =
              'UPLOADING…';




            status.textContent =
              '';




            status.dataset.state =
              '';




            /*
             * Actual completed Basin form.
             * This is the only request that
             * contains the actual room image.
             */




            const payload =
              new FormData(form);




            payload.set(
              'full_name',
              fullName.value.trim()
            );




            payload.set(
              'mobile',
              mobile.value.trim()
            );




            payload.set(
              'first_name',
              fullName.value
                .trim()
                .split(/\s+/)[0]
            );




            payload.set(
              'room_preview_session_id',
              sessionId
            );




            payload.set(
              'form_status',
              'completed'
            );




            attributionKeys.forEach(
              key => {
                if (
                  attribution[key]
                ) {
                  payload.set(
                    key,
                    attribution[key]
                  );
                }
              }
            );




            if (attribution.fbp) {
              payload.set(
                'fbp',
                attribution.fbp
              );
            }




            if (attribution.fbc) {
              payload.set(
                'fbc',
                attribution.fbc
              );
            }




            payload.set(
              'referrer',
              document.referrer || ''
            );




            payload.set(
              'current_url',
              location.href
            );




            try {
              const response =
                await fetch(
                  form.action,
                  {
                    method: 'POST',
                    body: payload,
                    headers: {
                      Accept:
                        'application/json'
                    },
                    signal
                  }
                );




              if (
                !response.ok
              ) {
                throw new Error(
                  'Upload failed'
                );
              }




              completed = true;




              form.hidden =
                true;




              success.classList.add(
                'is-visible'
              );




              success.setAttribute(
                'tabindex',
                '-1'
              );




              success.focus();




              /*
               * This is the successful
               * room preview event.
               *
               * This is the one I would
               * eventually map to Meta Lead.
               */




              publish(
                'velar_room_preview_success',
                {
                  velar_colour:
                    colour?.value || ''
                }
              );




              telemetry(
                'velar_room_preview_completed',
                {
                  step_index: 9,
                  last_completed_field:
                    'completed'
                }
              );
            } catch (error) {
              if (
                error.name ===
                'AbortError'
              ) {
                return;
              }




              status.dataset.state =
                'error';




              status.textContent =
                'Could not send the room preview request. Please try again.';




              publish(
                'velar_room_preview_error'
              );




              telemetry(
                'velar_room_preview_error',
                {
                  step_index: 8,
                  last_completed_field:
                    'submit'
                },
                {
                  allowRepeat: true
                }
              );




              submit.disabled =
                false;




              submit.textContent =
                submit.dataset
                  .defaultLabel;
            }
          },
          { signal }
        );
      }




      /*
       * ============================================================
       * ABANDONED FORM CAPTURE
       * ============================================================
       *
       * If someone:
       *
       * - enters their name
       * - enters their mobile
       * - enters their email
       * - selects a colour
       * - selects a photo
       *
       * and then leaves without pressing
       * submit, Basin receives the final
       * state we had before they left.
       */




      const abandon = () => {
        if (
          !started ||
          completed
        ) {
          return;
        }




        const hasAnyValue =
          Boolean(
            fullName?.value
              .trim() ||
            mobile?.value
              .trim() ||
            email?.value
              .trim() ||
            colour?.value ||
            fileInput
              ?.files
              ?.length
          );




        if (!hasAnyValue) {
          return;
        }




        /*
         * Behaviour only goes to GTM.
         * Contact values do not.
         */




        publish(
          'velar_room_preview_abandoned',
          {
            has_name:
              validName(),




            has_mobile:
              hasMobile() &&
              validMobile(),




            has_email:
              validEmail(),




            has_colour:
              Boolean(
                colour?.value
              ),




            has_photo:
              Boolean(
                fileInput
                  ?.files
                  ?.length
              )
          }
        );




        /*
         * Basin receives the actual
         * recoverable lead state.
         */




        telemetry(
          'velar_room_preview_abandoned',
          {
            last_completed_field:
              fileInput
                ?.files
                ?.length
                ? 'room_photo'
                : colour?.value
                ? 'velar_colour'
                : validEmail()
                ? 'email'
                : hasMobile() &&
                  validMobile()
                ? 'mobile'
                : validName()
                ? 'full_name'
                : '',




            has_name:
              validName()
                ? 'yes'
                : 'no',




            has_mobile:
              hasMobile() &&
              validMobile()
                ? 'yes'
                : 'no',




            has_email:
              validEmail()
                ? 'yes'
                : 'no',




            has_colour:
              colour?.value
                ? 'yes'
                : 'no',




            has_photo:
              fileInput
                ?.files
                ?.length
                ? 'yes'
                : 'no'
          },
          {
            beacon: true,
            keepalive: true
          }
        );
      };




      window.addEventListener(
        'pagehide',
        abandon,
        { signal }
      );




      /*
       * ============================================================
       * FAQ CATEGORY SWITCHER
       * ============================================================
       */




      const faqTabs =
        Array.from(
          this.querySelectorAll(
            '[data-vda-faq-tab]'
          )
        );




      const faqPanels =
        Array.from(
          this.querySelectorAll(
            '[data-vda-faq-panel]'
          )
        );




      const activateFaqPanel =
        (category) => {
          faqTabs.forEach(tab => {
            const active =
              tab.dataset.vdaFaqTab ===
              category;




            tab.classList.toggle(
              'is-active',
              active
            );




            tab.setAttribute(
              'aria-selected',
              active
                ? 'true'
                : 'false'
            );
          });




          faqPanels.forEach(panel => {
            const active =
              panel.dataset.vdaFaqPanel ===
              category;




            if (!active) {
              panel.hidden = true;
              panel.classList.remove(
                'is-active',
                'is-entering'
              );
              return;
            }




            panel.hidden = false;
            panel.classList.add(
              'is-active'
            );




            panel.classList.remove(
              'is-entering'
            );




            void panel.offsetWidth;




            panel.classList.add(
              'is-entering'
            );
          });
        };




      faqTabs.forEach(tab => {
        tab.addEventListener(
          'click',
          () => {
            activateFaqPanel(
              tab.dataset.vdaFaqTab
            );
          },
          { signal }
        );
      });




      this
        .querySelectorAll(
          '[data-velar-faq-toggle]'
        )
        .forEach(faqToggle => {
          const category =
            faqToggle.dataset
              .velarFaqToggle;




          const faqList =
            this.querySelector(
              `[data-velar-faq-list="${category}"]`
            );




          if (!faqList) {
            return;
          }




          faqToggle.addEventListener(
            'click',
            () => {
              const expanded =
                faqList.classList.toggle(
                  'is-expanded'
                );




              faqToggle.setAttribute(
                'aria-expanded',
                String(expanded)
              );




              faqToggle.textContent =
                expanded
                  ? faqToggle.dataset
                      .showLessLabel
                  : faqToggle.dataset
                      .showAllLabel;
            },
            { signal }
          );
        });




      if (faqTabs.length) {
        activateFaqPanel(
          faqTabs[0].dataset
            .vdaFaqTab
        );
      }
    }




    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dorsa-velar-direct-intro"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dorsa-velar-intro')) {
  customElements.define('dorsa-velar-intro', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;


      this.abort = new AbortController();


      const signal = this.abort.signal;
      const rail = this.querySelector('[data-vd-feature-rail]');
      const cue = this.querySelector('[data-vd-swipe-cue]');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');

      const vsl = this.querySelector('[data-vd-vsl]');
      if (vsl) {
        const film = vsl.querySelector('.vd-studio-vsl__video');
        const sound = vsl.querySelector('[data-vd-vsl-sound]');
        const soundLabel = vsl.querySelector('[data-vd-vsl-sound-label]');
        if (film && sound && soundLabel) {
          let inView = false;
          let wantsAudio = false;
          let initiated = false;
          film.muted = true;
          film.defaultMuted = true;
          film.playsInline = true;
          film.loop = true;
          film.controls = false;
          film.preload = 'none';
          const sync = () => {
            sound.setAttribute('aria-pressed', String(wantsAudio));
            sound.setAttribute('aria-label', wantsAudio ? 'Mute studio video' : 'Play studio video with sound');
            soundLabel.textContent = wantsAudio ? 'SOUND ON' : 'TURN SOUND ON';
            film.muted = !wantsAudio;
          };
          const play = () => {
            if (!this.isConnected || document.hidden || !inView) {
              film.pause();
              wantsAudio = false;
              sync();
              return;
            }
            if (motion.matches && !initiated) {
              film.pause();
              return;
            }
            film.preload = 'auto';
            sync();
            const attempt = film.play();
            if (attempt?.catch) attempt.catch(() => {
              if (wantsAudio) {
                wantsAudio = false;
                sync();
                film.play().catch(() => {});
              }
            });
          };
          sound.addEventListener('click', () => {
            initiated = true;
            wantsAudio = !wantsAudio;
            sync();
            play();
          }, { signal });
          this.vslObserver = new IntersectionObserver(entries => {
            inView = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= .25);
            play();
          }, { threshold: [0, .25, .5], rootMargin: '0px 0px 70px' });
          this.vslObserver.observe(vsl);
          document.addEventListener('visibilitychange', play, { signal });
          motion.addEventListener('change', play, { signal });
          film.addEventListener('error', () => {
            film.pause();
            wantsAudio = false;
            sync();
          }, { signal });
          sync();
        }
      }

this.featureVideoStates=Array.from(this.querySelectorAll('[data-vd-feature-sequence]')).map(stack=>{
const videos=[...stack.querySelectorAll('video')],state={stack,videos,index:0,visible:false,switching:false,timer:null};
if(!videos.length)return state;
videos.forEach((v,i)=>{v.muted=true;v.defaultMuted=true;v.playsInline=true;v.controls=false;v.preload='none';v.loop=videos.length===1;v.classList.toggle('is-front',i===0)});
const allowed=()=>this.isConnected&&state.visible&&!document.hidden&&!motion.matches;
state.pause=()=>videos.forEach(v=>v.pause());
state.play=()=>{if(!allowed()){state.pause();return}const v=videos[state.index];if(!v)return;videos.forEach(x=>x.preload='auto');v.play().then(()=>v.classList.add('is-active')).catch(()=>{})};
state.swap=()=>{if(videos.length<2||state.switching||!allowed())return;
const current=videos[state.index],next=videos[(state.index+1)%videos.length];state.switching=true;
try{next.currentTime=0}catch(e){}
next.play().then(()=>{if(!allowed()){state.switching=false;state.pause();return}
current.classList.remove('is-front');next.classList.add('is-front','is-active');
state.timer=setTimeout(()=>{current.classList.remove('is-active');current.pause();try{current.currentTime=0}catch(e){}state.index=videos.indexOf(next);state.switching=false},240);
}).catch(()=>{state.switching=false;current.loop=true;state.play()})};
videos.forEach((v,i)=>{v.addEventListener('timeupdate',()=>{if(i===state.index&&videos.length>1&&Number.isFinite(v.duration)&&v.duration-v.currentTime<=.55)state.swap()},{signal});v.addEventListener('ended',()=>{if(i===state.index)state.swap()},{signal})});
return state});
if(this.featureVideoStates.length){
this.featureVideoObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{const st=this.featureVideoStates.find(x=>x.stack===entry.target);if(st){st.visible=entry.isIntersecting&&entry.intersectionRatio>=.25;st.play?.()}}),{threshold:[0,.25,.5],rootMargin:'0px 60px'});
this.featureVideoStates.forEach(st=>this.featureVideoObserver.observe(st.stack));
const refresh=()=>this.featureVideoStates.forEach(st=>st.play?.());
document.addEventListener('visibilitychange',refresh,{signal});motion.addEventListener('change',refresh,{signal});
}



      if (rail && cue) {
        let dismissed = false;


        const update = () => {
          cue.hidden =
            dismissed ||
            rail.scrollWidth <= rail.clientWidth + 8;
        };


        rail.addEventListener(
          'scroll',
          () => {
            if (Math.abs(rail.scrollLeft) > 24) {
              dismissed = true;


              cue.classList.add('is-dismissed');


              cue.tabIndex = -1;
            }
          },
          {
            passive: true,
            signal
          }
        );


        cue.addEventListener(
          'click',
          () => {
            const card =
              rail.querySelector('.vd-feature');


            rail.scrollBy({
              left:
                (card?.getBoundingClientRect().width || rail.clientWidth)
                + 12,
              behavior:
                motion.matches
                  ? 'instant'
                  : 'smooth'
            });
          },
          {
            signal
          }
        );


        this.resize =
          new ResizeObserver(update);


        this.resize.observe(rail);


        this.cueObserver =
          new IntersectionObserver(
            entries => {
              if (
                entries.some(
                  entry => entry.isIntersecting
                )
              ) {
                cue.classList.add('is-visible');


                this.cueObserver.disconnect();
              }
            },
            {
              threshold: .5
            }
          );


        this.cueObserver.observe(cue);


        update();
      }


      /* ======================================================
         HERO VIDEO SEQUENCE


         One selected video:
         1 → 1 → 1 forever.


         Two selected videos:
         1 → 2 → 1 → 2 forever.
         ====================================================== */


      const media =
        this.querySelector('.vd-hero__media');


      const videos =
        media
          ? Array.from(
              media.querySelectorAll(
                '.vd-hero-video'
              )
            )
          : [];


      if (media && videos.length) {
        let visible = true;
        let activeIndex = 0;
        let switching = false;


        const isSequence =
          videos.length > 1;


        const transitionMs = 520;




        const prepareVideo = (
          video,
          index
        ) => {
          video.muted = true;
          video.defaultMuted = true;


          video.playsInline = true;
          video.controls = false;


          const preloadMode =
            index === 0
              ? 'auto'
              : 'metadata';


          video.preload =
            preloadMode;


          video.setAttribute(
            'muted',
            ''
          );


          video.setAttribute(
            'playsinline',
            ''
          );


          video.setAttribute(
            'webkit-playsinline',
            ''
          );


          video.setAttribute(
            'preload',
            preloadMode
          );


          video.removeAttribute(
            'controls'
          );


          if (isSequence) {
            video.loop = false;


            video.removeAttribute(
              'loop'
            );
          } else {
            video.loop = true;


            video.setAttribute(
              'loop',
              ''
            );
          }


          video.classList.toggle(
            'is-active',
            index === 0
          );


          if (index !== 0) {
            video.pause();


            try {
              video.currentTime = 0;
            } catch (error) {}
          }
        };




        const pauseAll = () => {
          videos.forEach(
            video => video.pause()
          );
        };




        const playActive = () => {
          if (!this.isConnected) {
            return;
          }


          if (
            motion.matches ||
            document.hidden ||
            !visible
          ) {
            pauseAll();


            if (motion.matches) {
              media.classList.remove(
                'is-playing'
              );
            }


            return;
          }


          const activeVideo =
            videos[activeIndex];


          if (!activeVideo) {
            return;
          }


          activeVideo.muted = true;
          activeVideo.defaultMuted = true;
          activeVideo.playsInline = true;


          const attempt =
            activeVideo.play();


          if (attempt?.catch) {
            attempt.catch(
              () => {
                media.classList.remove(
                  'is-playing'
                );
              }
            );
          }
        };




        const switchTo = nextIndex => {
          if (
            !isSequence ||
            switching ||
            nextIndex === activeIndex
          ) {
            return;
          }


          const currentVideo =
            videos[activeIndex];


          const nextVideo =
            videos[nextIndex];


          if (
            !currentVideo ||
            !nextVideo
          ) {
            return;
          }


          switching = true;


          nextVideo.muted = true;
          nextVideo.defaultMuted = true;
          nextVideo.playsInline = true;


          try {
            nextVideo.currentTime = 0;
          } catch (error) {}




          const finishSwitch = () => {
            activeIndex =
              nextIndex;


            /*
              Keep the outgoing video active for the
              duration of the crossfade. The incoming
              video is layered above it.
            */
            nextVideo.classList.add(
              'is-active'
            );


            media.classList.add(
              'is-playing'
            );


            window.clearTimeout(
              this.heroSequenceTimer
            );


            this.heroSequenceTimer =
              window.setTimeout(
                () => {
                  currentVideo.classList.remove(
                    'is-active'
                  );


                  currentVideo.pause();


                  try {
                    currentVideo.currentTime = 0;
                  } catch (error) {}


                  switching =
                    false;
                },
                transitionMs
              );
          };




          const attempt =
            nextVideo.play();


          if (attempt?.then) {
            attempt
              .then(
                finishSwitch
              )
              .catch(
                () => {
                  /*
                    If the second video fails for any
                    browser/network reason, don't leave
                    the hero blank. Return to the
                    previous film.
                  */
                  switching = false;


                  nextVideo.classList.remove(
                    'is-active'
                  );


                  currentVideo.classList.add(
                    'is-active'
                  );


                  try {
                    currentVideo.currentTime = 0;
                  } catch (error) {}


                  activeIndex =
                    videos.indexOf(
                      currentVideo
                    );


                  playActive();
                }
              );
          } else {
            finishSwitch();
          }
        };




        videos.forEach(
          (video, index) => {
            prepareVideo(
              video,
              index
            );


            video.addEventListener(
              'playing',
              () => {
                if (
                  video.classList.contains(
                    'is-active'
                  )
                ) {
                  media.classList.add(
                    'is-playing'
                  );
                }
              },
              {
                signal
              }
            );


            video.addEventListener(
              'ended',
              () => {
                if (
                  !isSequence ||
                  index !== activeIndex
                ) {
                  return;
                }


                switchTo(
                  (index + 1)
                  % videos.length
                );
              },
              {
                signal
              }
            );


            video.addEventListener(
              'error',
              () => {
                if (
                  isSequence &&
                  index === activeIndex
                ) {
                  switchTo(
                    (index + 1)
                    % videos.length
                  );
                } else if (!isSequence) {
                  media.classList.remove(
                    'is-playing'
                  );
                }
              },
              {
                signal
              }
            );


            if (index === 0) {
              video.addEventListener(
                'loadeddata',
                playActive,
                {
                  once: true,
                  signal
                }
              );
            }
          }
        );




        document.addEventListener(
          'visibilitychange',
          playActive,
          {
            signal
          }
        );


        document.addEventListener(
          'pointerdown',
          playActive,
          {
            once: true,
            passive: true,
            signal
          }
        );


        motion.addEventListener(
          'change',
          playActive,
          {
            signal
          }
        );




        this.videoObserver =
          new IntersectionObserver(
            entries => {
              visible =
                entries[0].isIntersecting;


              playActive();
            },
            {
              threshold: .05
            }
          );


        this.videoObserver.observe(
          media
        );


        playActive();
      }
    }


    disconnectedCallback() {
      this.vslObserver?.disconnect();
      this.querySelector('.vd-studio-vsl__video')?.pause();
this.featureVideoObserver?.disconnect();
this.featureVideoStates?.forEach(st=>{if(st.timer)clearTimeout(st.timer);st.pause?.()});
      this.abort?.abort();


      this.abort = null;


      this.resize?.disconnect();


      this.cueObserver?.disconnect();


      this.videoObserver?.disconnect();


      window.clearTimeout(
        this.heroSequenceTimer
      );


      this.querySelectorAll(
        '.vd-hero-video'
      ).forEach(
        video => video.pause()
      );
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
